import { render, staticRenderFns } from "./chat-messages.vue?vue&type=template&id=7203fe9e&scoped=true"
import script from "./chat-messages.vue?vue&type=script&lang=js"
export * from "./chat-messages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7203fe9e",
  null
  
)

export default component.exports